import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fg } from '@atlaskit/platform-feature-flags';
import { getAnalyticsClient, isSSR, Logger } from '../../../common/utils';
import { getBscGlobalState, initializeGlobalState } from '../../../common/utils/bsc-global-state';
import { WebStorageType } from '../../../services/web-storage-service';
import { createDocumentCookiePassthrough } from './create-document-cookie-passthrough';
import { createWebStoragePassthrough } from './create-web-storage-passthrough';
export var initializeControls = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var args,
      analyticsWebClientInstance,
      isAnalyticsInitialized,
      isWebStorageControlsEnabled,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
            analyticsEnabled: true
          };
          if (!fg('platform_moonjelly_bsc_master_killswitch')) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.prev = 3;
          Logger.debug('initializeControls invoked');
          initializeGlobalState(args);

          // Exit silently if in SSR context
          if (!isSSR()) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          // Ensures that the AWC is constructed before overwriting any native methods.
          analyticsWebClientInstance = getAnalyticsClient(); // If AWC is not initialized, it will be undefined
          isAnalyticsInitialized = !!analyticsWebClientInstance;
          if (!(args.analyticsEnabled && !isAnalyticsInitialized)) {
            _context.next = 12;
            break;
          }
          throw new Error("Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.");
        case 12:
          _context.next = 14;
          return createDocumentCookiePassthrough();
        case 14:
          isWebStorageControlsEnabled = getBscGlobalState().webStorageEnabled;
          if (isWebStorageControlsEnabled) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return");
        case 17:
          _context.next = 19;
          return createWebStoragePassthrough(WebStorageType.LocalStorage);
        case 19:
          _context.next = 21;
          return createWebStoragePassthrough(WebStorageType.SessionStorage);
        case 21:
          Logger.debug('initiizeControls finished');
          _context.next = 27;
          break;
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](3);
          Logger.errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: "Failed to initialize browser storage controls. ".concat(_context.t0.message || '')
          });
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 24]]);
  }));
  return function initializeControls() {
    return _ref.apply(this, arguments);
  };
}();
export { createDocumentCookiePassthrough, createWebStoragePassthrough };